import * as React from 'react';
import cancelEvent from '../../../../services/mini/cancelEvent';
import * as _ from 'lodash';
import QrCodeView from '../QrCodeView/QrCodeView';
import formats from '../../../../const/formats';
import * as  moment from 'moment';
import getJsonSummary from '../../../../services/mini/getJsonSummary';
import ChatMessages from '../../../../services/dataKeepers/ChatMessages';
import { confirmAlert } from '../../../../services/mini/alanConfirmAlert';
import TestWithPlaugroundPopup from '../TestWithPlaugroundPopup/TestWithPlaugroundPopup';
import getContentWithChunks from '../../../../services/mini/getContentWithChunks';
import PopupWrapper from '../../../components/Popup/PopupWrapper';
import PopupHeader from '../../../components/Popup/PopupHeader';
import PopupBody from '../../../components/Popup/PopupBody';
import { IChatMessage, ICommandMessage, IRequestMessage, IResponseMessage, ITextMessage, IVisualStateMessage } from '../../../../models/IChatMessage';
import { IProject } from '../../../../models/IProject';
import FileLineLocInfo from '../FileLineLocInfo/FileLineLocInfo';
import { FileLineLocInfoTypes } from '../FileLineLocInfo/FileLineLocInfoTypes';
import { ChatMessageType } from '../../../../const/chatMessageType';
import { ChatMessageName } from '../../../../const/chatMessageName';
import { ChatBubbleImages } from '../ChatBubbleImages/ChatBubbleImages';
import { PopupType } from '../../../../../../alan_btn/src/model/PopupType';
import { replaceAttrInPopupHtml } from '../../../../../../alan_btn/src/textChat/helpers/replaceAttrInPopupHtml';
import { highlightCode } from '../../../../../../alan_btn/src/textChat/highlightJs';
import { getChatButtonsStyle } from '../../embed/TextChat/TextChatPreview/getChatButtonsStyle';
import { getProjectOptionsByEnvironment } from '../../../../services/mini/getProjectOptionsByEnvironment';
import { Environment } from '../../../../const/environment';
import { processFormulas } from '../../../../../../alan_btn/src/textChat/mathjax';
import { renderButtons } from '../../../../../../alan_btn/src/textChat/chatButtons';
import { alanMarkdown } from '../../../../../../alan_btn/src/textChat/alanMarkdown';
import { buildLinksContent, LEARN_MORE_LABEL } from '../../../../../../alan_btn/src/textChat/buildLinksContent';
import escapeOnErrorCode from '../../../../services/mini/escapeOnErrorCode';
import { buildCommandsBlock, changeMsgLikeStatus, deleteHiddenImagesWithCode, resetStylesForLikeAndDislikeBtns } from '../../../../../../alan_btn/src/textChat/buildCommandsBlock';
import getUrlInfo from '../../../../services/mini/getUrlInfo';
import copyTextToBuffer from '../../../../services/mini/copyTextToBuffer';
import { OpGraphLogIcon } from '../../../components/LogLine/logIcons';
import { isMsgContainsIFrame } from '../../../../../../alan_btn/src/textChat/helpers/chat';
import { MessageProgress } from '../MessageProgress/MessageProgress';
import { StopResponseButton } from '../StopResponseButton/StopResponseButton';

function getParentClass(message) {
    return `alan-popup-${message.ui_id} `;
}

function modufyStyles(style, message) {
    const parentClass = getParentClass(message);
    return style ? style.replace(/(\.-?[_a-zA-Z]+[_a-zA-Z0-9-]*\s*\{)/gi, `.${parentClass} $&`) : '';
}

function getInfoMsg(message) {
    return <span className="chat-bubble_try-message">{message.intro} {message.phrases.map((phrase, i) => {
        return <React.Fragment key={phrase}><b>"{phrase}"</b> {i !== message.phrases.length - 1 ? ' or ' : ''}</React.Fragment>;
    })} (press Enter or click the send icon <i className="icon icon-alan-send"></i> in the area bellow)</span>;
}

function showPopup(message) {
    confirmAlert({
        customUI: ({ onClose }) => {
            const parentClass = getParentClass(message);
            return (
                <PopupWrapper className="transparent">
                    <PopupHeader className="white" onCancel={onClose} />
                    <PopupBody>
                        <div className="chat-bubble_popup_preview">
                            <style>
                                {modufyStyles(message.data.style, message)}
                            </style>
                            <div dangerouslySetInnerHTML={{ __html: `<div class="${parentClass}">` + message.data.html + '</div>' }} />
                        </div>
                    </PopupBody>
                </PopupWrapper>
            );
        }
    });
}


const bubbleBody = {
    [ChatMessageType.Buttons]: (message, onClickSpecialCb, options) => {
        return <div className="chat-bubble_text-chat-buttons-content"
            onClick={onClickSpecialCb}
            dangerouslySetInnerHTML={{
                __html: `
            <style>${getChatButtonsStyle('alan-chat', 'web', options)}</style>
            ${renderButtons(message?.data?.buttons || [])}
            ` }}
        />;
    },

    [ChatMessageType.Popup]: (message, onClickSpecialCb) => {
        const parentClass = getParentClass(message);

        if (message?.data?.type === PopupType.Chat) {
            return <div className="chat-bubble_popup_text-chat-content" onClick={onClickSpecialCb}>
                <style>
                    {modufyStyles(message.data.style, message)}
                </style>
                <div dangerouslySetInnerHTML={
                    { __html: `<div class="${parentClass}">${replaceAttrInPopupHtml(message.data.html)}</div>` }
                } />
            </div>;
        }

        return <div
            className="chat-bubble_popup_content"
            onClick={() => showPopup(message)}>
            <style>
                {modufyStyles(message.data.style, message)}
            </style>
            <div dangerouslySetInnerHTML={{ __html: `<div class="${parentClass}">` + message.data.html + '</div>' }} />
            <div className="chat-bubble_popup_overlay">
                Click here to see content
            </div>
        </div>;
    },
    [ChatMessageType.Command]: (message) => {
        return <div>
            {message.commandData.map((command) => {
                return <div key={command.id}
                    className="chat-bubble_command-data">
                    <div>{getJsonSummary(command.data)}</div>
                </div>;
            })}
        </div>;
    },
    [ChatMessageType.QrCode]: (message, onClickSpecialCb) => {
        return <div className="chat-bubble_msg">
            <i className="icon icon-alan-help-sign playground-icon" title="Test Your Project With Alan Playground" onClick={onClickSpecialCb} />
            <QrCodeView text={message.text} />
        </div>;
    },
    [ChatMessageType.Info]: (message) => {
        return <div className="chat-bubble_msg">
            {getInfoMsg(message)}
        </div>;
    },
    [ChatMessageType.Reconnect]: (message) => {
        return <div className="chat-bubble_reconnect-msg" />;
    },
    [ChatMessageType.VisualState]: (message) => {
        return <div className={`chat-bubble_msg visual-state`}
            title={`Visual State #${message.visualStateIndex}`}>
            {message.text}
            {message.data && <div>{getJsonSummary(message.data)}</div>}
        </div>;
    },
    [ChatMessageType.ConnectionState]: (message) => {
        return <div className={`chat-bubble_msg connection-state`}>
            {message.connected ?
                <i className="icon icon-alan-mobile-connected" /> :
                <i className="icon icon-alan-mobile-disconnected" />
            }
            {message.text}
        </div>;
    },
    [ChatMessageType.Text]: (message, onClickSpecialCb, textChatOptions) => {

        if (message.name === ChatMessageName.Loading) {
            return <div className="chat-bubble_msg chat-bubble_loading">
                <MessageProgress message={message} key={message?.queryProgressUpdateTs} />
            </div>;
        }

        const inspectUrl = message.ctx?.inspectURL;

        const onBottomBtnClickListener = (e) => {
            cancelEvent(e);

            const copyBtnEl = e.target.closest('.alan-btn__chat-response__copy-btn');

            if (copyBtnEl) {
                let textToCopy = '';
                if (message) {
                    textToCopy = deleteHiddenImagesWithCode(message.text || '');
                    copyTextToBuffer(
                        (message.images?.length > 0 ? (message.images?.map(img => img.src).join('\n') + '\n\n') : '') +
                        textToCopy +
                        (message.links?.length > 0 ? (`\n\n${LEARN_MORE_LABEL}\n` + message.links?.map(link => link.href).join('\n')) : '')
                    );
                }

                copyBtnEl.classList.add('alan-copy-btn-copied');
                setTimeout(() => {
                    copyBtnEl?.classList?.remove('alan-copy-btn-copied');
                }, 2000);
                return;
            }

            const likeBtnEl = e.target.closest('.alan-btn__chat-response__like-btn');
            const dislikeBtnEl = e.target.closest('.alan-btn__chat-response__dislike-btn');

            if (likeBtnEl) {
                message.liked = message.liked !== 1 ? 1 : 0;
            }
            if (dislikeBtnEl) {
                message.liked = message.liked !== -1 ? -1 : 0;
            }
            changeMsgLikeStatus(message);
            resetStylesForLikeAndDislikeBtns(e.target.closest('.chat-bubble_message'), message);
        }

        const { isTestMode } = getUrlInfo();

        return <div className={`chat-bubble_msg with-markdown`}>
            {message.images?.length > 0 ? <ChatBubbleImages message={message} /> : <></>}
            <div dangerouslySetInnerHTML={message.ctx?.format === 'markdown' ? { __html: alanMarkdown(escapeOnErrorCode(message?.text || '')) } : getContentWithChunks(message.text, message.ents)} />

            {message.links?.length > 0 ?
                <div dangerouslySetInnerHTML={{ __html: buildLinksContent({ ...message, text: escapeOnErrorCode(message?.text || '') }) }} />
                : <></>}

            {(!isTestMode && message.my !== true) && <div
                onClick={onBottomBtnClickListener}
                dangerouslySetInnerHTML={{ __html: buildCommandsBlock({ ...message, type: 'response' }, textChatOptions) }} />}

            {(message.ctx?.final === false && message.my !== true) ? <div className="chat-bubble_incomming-msg-loader">
                <StopResponseButton message={message} />
            </div> : <></>}

            {/* {inspectUrl && <a
                className="chat-bubble_inspect-url"
                href={inspectUrl}
                target="_blank"
                rel="noreferrer" >
                <i className="icon icon-alan-debug-sign" />
            </a>} */}
            {(message.reqId && message.my !== true) && <span className='chat-bubble_graph' data-request-id={message.reqId}><OpGraphLogIcon /></span>}
        </div >;
    }
};

interface IShowFullCommandsParams {
    commandInfo: IChatMessage,
    commands: IChatMessage[],
    openPanel: boolean
}

interface IShowFullVisualStateParams {
    visualStateIndex: number,
    visualStates?: IVisualStateMessage[],
}

interface ISelectVisualStateParams {
    visaulState: number,
}

type ChatBubbleProp = {
    message: ICommandMessage | IResponseMessage | IRequestMessage | IVisualStateMessage;
    ts: number;
    project: IProject
    visualStatePanelOpened: boolean
    selectedVisualStateTs: number
    environment: Environment;
    isTestMode?: boolean;
    rememberChatScrollPosition: () => void;
    showFullCommands: (param: IShowFullCommandsParams) => void;
    showFullVisualState: (param: IShowFullVisualStateParams) => void;
    selectVisualState: (param: ISelectVisualStateParams) => void;
    onTextChatPopupClick: (e) => void;
    onTextChatButtonClick: (e) => void;
}

type ChatBubbleState = {
    locInfoHovered: boolean
}

class ChatBubble extends React.Component<ChatBubbleProp, ChatBubbleState> {

    constructor(props) {
        super(props);
        this.state = {
            locInfoHovered: false
        };
    }

    componentDidMount(): void {
        this.applyFormatters();
    }

    componentDidUpdate(): void {
        this.applyFormatters();
    }

    applyFormatters = () => {
        const {
            message,
        } = this.props;

        try {

            processFormulas(document.querySelector(`[data-bubble-ts="${message.ts}"]`).querySelector('.chat-bubble_msg') as HTMLDivElement);

            highlightCode(document.querySelector('.debugging-chat_messages'));
        } catch (error) {

        }

    }

    onClick = () => {
        const {
            message,
            rememberChatScrollPosition,
            showFullCommands,
            showFullVisualState
        } = this.props;

        console.info('MESSAGE', message);

        if (message.type === ChatMessageType.Command) {
            rememberChatScrollPosition();
            showFullCommands({
                commandInfo: message,
                commands: _.filter(ChatMessages.getMessages(), { type: ChatMessageType.Command }),
                openPanel: true
            });
        }

        if (message.type === ChatMessageType.VisualState) {
            rememberChatScrollPosition();
            showFullVisualState({
                visualStateIndex: message.visualStateIndex,
                visualStates: _.filter(ChatMessages.getMessages(), { type: ChatMessageType.VisualState })
            });
        }
    }

    showTestPlaygroundPopup = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <TestWithPlaugroundPopup
                        onClose={onClose} />
                );
            }
        });
    }

    openVisualState = (e) => {
        const {
            message,
            showFullVisualState,
            selectVisualState
        } = this.props;

        showFullVisualState({
            visualStateIndex: message.visualStateIndex
        });
        selectVisualState({ visaulState: message.ts });
        cancelEvent(e);
    }

    onCommandLocInfoAfterClick = (e) => {
        cancelEvent(e);
    }

    onLocInfoMouseEnter = (e) => {
        this.setState({ locInfoHovered: true });
    }

    onLocInfoMouseLeave = (e) => {
        this.setState({ locInfoHovered: false });
    }

    renderBubbleBody = (type, message, onClickSpecialCb) => {
        const { project, environment } = this.props;

        const webOptions = getProjectOptionsByEnvironment(project, 'web', environment, [], null)['web'];
        const textChatOptions = webOptions?.chatOptions?.textChat;

        if (type === ChatMessageType.Buttons) {
            return bubbleBody[type](message, onClickSpecialCb, webOptions);
        }
        if (type) {
            return bubbleBody[type](message, onClickSpecialCb, textChatOptions);
        }
        return bubbleBody[ChatMessageType.Text](message, onClickSpecialCb, textChatOptions);
    }

    render() {
        const { message, visualStatePanelOpened, selectedVisualStateTs, isTestMode } = this.props;
        const { locInfoHovered } = this.state;
        const showTs = [
            ChatMessageType.ConnectionState,
            ChatMessageType.VisualState,
        ].indexOf(message.type) > -1;

        const withIframe = isMsgContainsIFrame((message as any)?.text);

        let messageClass = `chat-bubble chat-bubble_${message.type}`;

        if (message.type === ChatMessageType.Text) {
            messageClass = (message as ITextMessage).my ? 'chat-bubble_my-message' : 'chat-bubble_message';
            messageClass += !(message as ITextMessage).final ? ' not-final' : '';
        }

        if ((message as any).name === ChatMessageName.Loading) {
            messageClass += ' chat-bubble_loading-msg';
        }

        if (withIframe) {
            messageClass += ' with-iframe';
        }

        let clickCb = undefined;

        if (message.type === ChatMessageType.QrCode && this.showTestPlaygroundPopup) {
            clickCb = this.showTestPlaygroundPopup;
        }

        if (message.type === ChatMessageType.Popup) {
            clickCb = this.props.onTextChatPopupClick;
        }

        if (message.type === ChatMessageType.Buttons) {
            clickCb = this.props.onTextChatButtonClick;
        }

        const isTopStopBtnShown = (message as ITextMessage).isHidden !== true &&
            ChatMessages.canMsgBeStopped(message as ITextMessage) && (message as any).name === ChatMessageName.Loading;

        if (message.isHidden) return <></>;

        return (
            <div className={`${messageClass} ${(visualStatePanelOpened && message.type !== ChatMessageType.VisualState) && 'inactive-bubble'} ${selectedVisualStateTs === message.ts && 'highlighted'} ${locInfoHovered && 'loc-info-hovered'}`}
                data-bubble-ts={message.ts}
                onClick={this.onClick}>

                {(isTopStopBtnShown && !isTestMode) && <StopResponseButton message={message} />}

                {(showTs) &&
                    <div className="chat-bubble_header">
                        {moment(message.ts).format(formats.MM_DD_YYYY_hh_mm_a)}
                    </div>}
                {message.visualStateIndex > 0 &&
                    <div className="chat-bubble_visual-state-link"
                        onClick={this.openVisualState} onMouseEnter={this.onLocInfoMouseEnter}
                        onMouseLeave={this.onLocInfoMouseLeave}>
                        {`{#${message.visualStateIndex}}`}
                    </div>}
                {((message as ITextMessage).my) &&
                    <FileLineLocInfo
                        visualStateIndex={message.visualStateIndex}
                        type={FileLineLocInfoTypes.Request}
                        className={message.visualStateIndex > 0 && 'with-vs'}
                        locData={(message as IRequestMessage).pLoc}
                    />}
                {(message.type === ChatMessageType.Text && !(message as ITextMessage).my) &&
                    <FileLineLocInfo
                        visualStateIndex={message.visualStateIndex}
                        type={FileLineLocInfoTypes.Response}
                        className={message.visualStateIndex > 0 && 'with-vs'}
                        locData={(message as IResponseMessage).rLoc}
                    />}
                {message.type === ChatMessageType.Command &&
                    <FileLineLocInfo
                        type={FileLineLocInfoTypes.Response}
                        visualStateIndex={message.visualStateIndex}
                        className={message.visualStateIndex > 0 && 'with-vs'}
                        locData={(message as ICommandMessage).commandData[0]?.ctx?.rLoc}
                        onAfterClick={this.onCommandLocInfoAfterClick}
                        onMouseEnter={this.onLocInfoMouseEnter}
                        onMouseLeave={this.onLocInfoMouseLeave}
                    />
                }
                {this.renderBubbleBody(message.type, message, clickCb)}
            </div>
        );
    }
}

export default ChatBubble;
